import { DownOutlined, FilterOutlined, SortDescendingOutlined, ThunderboltOutlined } from '@ant-design/icons'
import { Checkbox, Dropdown, Menu } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Group, PostType, ThanksPostInfoFragment } from '@/generated/graphql'
import { PostsSortBy } from '@/modules/post/post.hooks'

import s from './posts-actions.module.less'

interface PostsActionsProps {
  group?: Group
  posts: ThanksPostInfoFragment[]
  refetch: () => void
  defaultPostType: PostType[]
  postTypes: PostType[]
  setPostType: (postType: PostType[]) => void
  sortBy: PostsSortBy
  setSortBy: (sortBy: PostsSortBy) => void
  useRecommendation: boolean
  setUseRecommendation: (useRecommendation: boolean) => void
  showRecommendationSwitcher?: boolean
}

interface PostsSorterProps {
  sortBy: PostsSortBy
  setSortBy: (sortBy: PostsSortBy) => void
}

export const PostsActions: React.FC<PostsActionsProps> = ({
  group,
  posts,
  refetch,
  defaultPostType,
  postTypes,
  setPostType,
  sortBy,
  setSortBy,
  useRecommendation,
  setUseRecommendation,
  showRecommendationSwitcher,
}) => {
  const [t] = useTranslation()

  const onChangeRecommendation = () => {
    if (useRecommendation) {
      setPostType(defaultPostType)
      setSortBy('createdAtDesc')
    }
    setUseRecommendation(!useRecommendation)
  }

  const recommendationSwitcher = showRecommendationSwitcher && (
    <a onClick={onChangeRecommendation}>
      <ThunderboltOutlined style={{ marginRight: 4 }} />
      {useRecommendation ? '使用关注模式' : '使用推荐模式'}
    </a>
  )

  const onChangeFilter = (list: any) => {
    setPostType(list)
    if (list.length === 0) {
      setPostType(defaultPostType)
    }
    refetch()
    window.scrollTo({ top: 0 })
  }

  const filterMenu = (
    <Menu>
      <Checkbox.Group
        className={s.filterItems}
        defaultValue={defaultPostType}
        value={postTypes}
        onChange={onChangeFilter}
      >
        <Checkbox value={PostType.General}>{t('post.general')}</Checkbox>
        {!group && <Checkbox value={PostType.Thanks}>{t('post.thanks.thanks')}</Checkbox>}
        <Checkbox value={PostType.Forum}>{t('post.forum.forum')}</Checkbox>
        <Checkbox value={PostType.Introduction}>{t('post.introduction')}</Checkbox>
        <Checkbox value={PostType.Journal}>{t('post.journal.name')}</Checkbox>
      </Checkbox.Group>
    </Menu>
  )

  const filter = (
    <div className={s.filter}>
      <Dropdown overlay={filterMenu} trigger={['click']}>
        <a>
          <FilterOutlined style={{ marginRight: 4 }} />
          {t('post.filter')} <DownOutlined />
        </a>
      </Dropdown>
    </div>
  )

  const sortMenu = (
    <Menu onClick={(e) => setSortBy(e.key as PostsSortBy)}>
      <Menu.Item key='createdAtDesc'>{t('sort.time.newest')}</Menu.Item>
      <Menu.Item key='createdAtAsc'>{t('sort.time.oldest')}</Menu.Item>
      <Menu.Item key='likedDesc'>{t('sort.like.desc')}</Menu.Item>
    </Menu>
  )

  const sortLabel = ((): string => {
    switch (sortBy) {
      case 'createdAtDesc':
        return t('sort.time.newest')
      case 'createdAtAsc':
        return t('sort.time.oldest')
      case 'likedDesc':
        return t('sort.like.desc')
    }
  })()

  const sorter = (
    <div className={s.sorter}>
      <Dropdown overlay={sortMenu} trigger={['click']}>
        <a>
          <SortDescendingOutlined style={{ marginRight: 4 }} />
          {sortLabel} <DownOutlined />
        </a>
      </Dropdown>
    </div>
  )

  return (
    <div className={s.postsAction}>
      <div>{recommendationSwitcher}</div>
      <div>
        {!useRecommendation && posts.length > 0 && filter}
        {!useRecommendation && posts.length > 0 && sorter}
      </div>
    </div>
  )
}

export const PostsSorter: React.FC<PostsSorterProps> = ({ sortBy, setSortBy }) => {
  const [t] = useTranslation()

  const sortMenu = (
    <Menu onClick={(e) => setSortBy(e.key as PostsSortBy)}>
      <Menu.Item key='createdAtDesc'>{t('sort.time.newest')}</Menu.Item>
      <Menu.Item key='createdAtAsc'>{t('sort.time.oldest')}</Menu.Item>
      <Menu.Item key='likedDesc'>{t('sort.like.desc')}</Menu.Item>
    </Menu>
  )

  const sortLabel = ((): string => {
    switch (sortBy) {
      case 'createdAtDesc':
        return t('sort.time.newest')
      case 'createdAtAsc':
        return t('sort.time.oldest')
      case 'likedDesc':
        return t('sort.like.desc')
    }
  })()

  const sorter = (
    <div className={s.sorter}>
      <Dropdown overlay={sortMenu} trigger={['click']}>
        <a>
          <SortDescendingOutlined style={{ marginRight: 4 }} />
          {sortLabel} <DownOutlined />
        </a>
      </Dropdown>
    </div>
  )
  return sorter
}
